export function getCopyString(
  copy: { [s in Intl.LDMLPluralRule]?: string } | string,
  n: number,
): string {
  if (typeof copy === 'string') {
    return copy
  }
  return copy[new Intl.PluralRules('en').select(n)] ?? ''
}
